import { Controller } from "@hotwired/stimulus"

// Matches Phoenix theme (app/assets/vendor/js/phoenix.js handleNavbarVerticalCollapsed)
const STORAGE_KEY = "phoenixIsNavbarVerticalCollapsed"
const CLASS_NAME = "navbar-vertical-collapsed"

export default class extends Controller {
  connect() {
    this.#syncFromStorage()
  }

  toggle(event) {
    event.preventDefault()
    document.documentElement.classList.toggle(CLASS_NAME)
    const collapsed = document.documentElement.classList.contains(CLASS_NAME)
    localStorage.setItem(STORAGE_KEY, JSON.stringify(collapsed))
    this.element.blur()
    window.dispatchEvent(new Event("resize"))
  }

  #syncFromStorage() {
    const raw = localStorage.getItem(STORAGE_KEY)
    let collapsed = false
    if (raw !== null) {
      try {
        collapsed = raw === "true" || JSON.parse(raw) === true
      } catch {
        collapsed = raw === "true"
      }
    }
    document.documentElement.classList.toggle(CLASS_NAME, collapsed)
  }
}
